import {
  AnyAccountId,
  anyAccountId,
  RoomContextId,
  roomContextId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomAccountDeleteEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomAccountDeleteEventDTO.validationSchema()
  );

  constructor(readonly data: RoomAccountDeleteEventDTORaw) {
    JsonSchemaValidator.assert(RoomAccountDeleteEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId", "roomId", "roomContextId"],
      properties: {
        accountId: anyAccountId,
        roomId,
        roomContextId
      },
      additionalProperties: false
    };
  }
}

export interface RoomAccountDeleteEventDTORaw {
  accountId: AnyAccountId;
  roomId: RoomId;
  roomContextId: RoomContextId;
}
